import React, { useState } from "react";
import {
  Row,
  Col,
  Form,
  FormInput,
  FormGroup,
  InputGroup,
  Button
} from "shards-react";
import "./Login.css";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase";
import { useAuth } from "../../providers/AuthProvider";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { error } = useAuth();

  const submit = async () => {
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (error) {
      if (error.code === "auth/user-not-found") {
        alert("Email is not registred");
      } else {
        alert(error.message);
      }
    }
  };

  return (
    <Row className="main_row">
      <Col sm="12" md="6">
        <h4 className="header_text">Login Form</h4>
        <Form>
          <FormGroup>
            <InputGroup className="mb-3">
              <FormInput
                placeholder="Email"
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
            </InputGroup>
          </FormGroup>
          <FormGroup>
            <FormInput
              type="password"
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
          </FormGroup>
          {error && <p className="text-center">{error}</p>}
          <Button theme="success" className="submit_button" onClick={submit}>
            Submit
          </Button>
        </Form>
      </Col>
    </Row>
  );
}
export default Login;
